const defaultAggregate = () => ({
  responses: 0,
  averageScore: 0,
  correct: 0,
  partiallyCorrect: 0,
  incorrect: 0,
  selections: [],
});

export const PlainSelectionsReducer = props => {
  const { selections, accSelections } = props || {};
  const selectionsKeys = Object.keys(selections || {}) || [];

  return (selectionsKeys || []).reduce((acc, categoryKey) => {
    if (!acc[categoryKey]) {
      acc[categoryKey] = { count: 0, value: selections[categoryKey].value };
    }

    acc[categoryKey].count += selections[categoryKey].count;

    return acc;
  }, accSelections);
};

export const TreeSelectionsReducer = props => {
  const { selections, accSelections } = props || {};
  const selectionsKeys = Object.keys(selections || {}) || [];

  return (selectionsKeys || []).reduce((acc, categoryKey) => {
    if (!acc[categoryKey]) {
      acc[categoryKey] = {};
    }

    const selectionsForCategory = selections[categoryKey];
    const selectionsForCategoryKeys = Object.keys(selectionsForCategory);

    return {
      ...acc,
      [categoryKey]: (selectionsForCategoryKeys || []).reduce(
        (acc2, choiceKey) => {
          if (!acc2[choiceKey]) {
            // eslint-disable-next-line no-param-reassign
            acc2[choiceKey] = {
              count: 0,
              value: selectionsForCategory[choiceKey].value,
            };
          }

          // eslint-disable-next-line no-param-reassign
          acc2[choiceKey].count += selectionsForCategory[choiceKey].count;

          return acc2;
        },
        acc[categoryKey]
      ),
    };
  }, accSelections);
};

export const AggregateMap = SelectionsAggregator => props => {
  try {
    const { question, responses } = props;
    const { element } = question;

    const aggregate = (responses || []).reduce((acc, response) => {
      const { score } = response || {};

      acc.element = element;
      acc.responses += 1;

      // populate score data
      if (score) {
        const { points, max } = score || {};

        acc.averageScore += points;

        if (points <= 0) {
          acc.incorrect += 1;
        } else if (points === max) {
          acc.correct += 1;
        } else {
          acc.partiallyCorrect += 1;
        }
      }

      acc.selections = SelectionsAggregator({ question, responses });

      return acc;
    }, defaultAggregate());

    aggregate.averageScore =
      aggregate.averageScore && aggregate.responses
        ? aggregate.averageScore / aggregate.responses
        : 0;

    return aggregate;
  } catch (e) {
    console.error(e);

    return defaultAggregate();
  }
};

export const AggregateReduce = SelectionsReducer => props => {
  try {
    const { aggregates } = props;
    const reducedAggregates = (aggregates || []).reduce((acc, aggregate) => {
      const { selections } = aggregate || {};

      acc.element = aggregate.element;
      acc.responses += aggregate.responses;
      acc.averageScore += aggregate.averageScore;
      acc.correct += aggregate.correct;
      acc.partiallyCorrect += aggregate.partiallyCorrect;
      acc.incorrect += aggregate.incorrect;
      acc.selections = SelectionsReducer({
        accSelections: acc.selections,
        selections,
      });

      return acc;
    }, defaultAggregate());

    reducedAggregates.averageScore /= aggregates.length || 1;

    return reducedAggregates;
  } catch (e) {
    console.error(e);

    return defaultAggregate();
  }
};
